module.exports = __webpack_public_path__ + "img/error.2bce87b6.svg";